module.exports = __webpack_public_path__ + "img/提现.7238fd2e.svg";